import { Route, Routes, Navigate } from "react-router";
import { 
  ControlMensajeria, 
  ControlMensajeriaReporte,
  SolicitudEmpleado
} from "../pages/ControlMensajeria";

import { RequiredPermission } from "../authentication/RequiredPermission";

export const RutasControlMensajeria = () => {

  return (
    <Routes>

      <Route element={<RequiredPermission permission={['ROLE_ADMIN', 'ROLE_VER_CONTROL_MENSAJERIA']} />}>
        <Route index element={<ControlMensajeria />} />
        <Route path="reporte" element={<ControlMensajeriaReporte />} />
      </Route>

      <Route path="solicitud" element={<SolicitudEmpleado />} />

      <Route path='/*' element={<Navigate to="/" replace />} />

    </Routes>
  );
};
